import { useCallback, useState } from 'react';
import { makeSureStartWithPlusOrEmpty } from '@monoimin/utils/helpers';
import { AsYouType, CountryCode } from 'libphonenumber-js';
import { PhoneCountry } from '@monoimin/sb-types';

type UsePhoneDigitsArgs = {
  defaultPhoneCountry?: PhoneCountry | null;
};

/**
 * @deprecated После перехода на новую форму, хук нужно будет удалить
 */
export const usePhoneDigits = ({ defaultPhoneCountry }: UsePhoneDigitsArgs) => {
  const [phone, setPhone] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');

  const [isValid, setIsValid] = useState(false);

  const handlePhoneChange = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = makeSureStartWithPlusOrEmpty(event.target.value);

      if (!value || value === '+') {
        setPhoneCountryCode('');
      }

      const asYouType = new AsYouType({
        defaultCountry: defaultPhoneCountry?.countryCode as CountryCode,
        defaultCallingCode: defaultPhoneCountry?.callingCode,
      });

      const input = asYouType.input(value);

      const country = asYouType.getNumber()?.country;

      const isValidValue = asYouType.isPossible();

      if (country) {
        setPhoneCountryCode(country);
      }

      setPhone(input);

      setIsValid(isValidValue);
    },
    [phone, setPhone, setPhoneCountryCode]
  );

  return {
    phone,
    isValid,
    setPhone,
    phoneCountryCode,
    setPhoneCountryCode,
    handlePhoneChange,
  };
};
